document.addEventListener('DOMContentLoaded', function () {
  const teamCollections = document.querySelectorAll('.kf_teamcollection__category_list');
  teamCollections && teamCollections.forEach(function (team) {
    const nextEle = team.closest('.kf_teamcollection__category_wrap').querySelector('.collList-next-button');
    const prevEle = team.closest('.kf_teamcollection__category_wrap').querySelector('.collList-prev-button');
    var swiper = new Swiper(team, {
      slidesPerView: 2.005,
      spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: nextEle,
        prevEl: prevEle,
      },
      breakpoints: {
        450: {
          slidesPerView: 2.8,
          spaceBetween: 10,
        },
        576: {
          slidesPerView: 3.5,
          spaceBetween: 10,
        },
        650: {
          slidesPerView: 3.8,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        990: {
          slidesPerView: 4.5,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
    });
  });
});

// ==========================  Checkout block Back to cart js ============================= //

document.addEventListener("DOMContentLoaded", function(event) {
    if (window.location.href.indexOf("?cart") > -1) {
        document.querySelector("#cart-icon-bubble").click();
    }
    setTimeout(() =>{
      if (window.location.href.indexOf("?cart") > -1) {
          window.history.pushState({}, document.title, `${document.querySelector("body").getAttribute("data-shop")}`);
      }
    } , 1000)
  })


// ==========================  Child menu active class add and remove on hover Start ============================= //
  document.querySelectorAll('.block__childlink-item').forEach(item => {
    item.addEventListener('mouseenter', () => {
      const siblings = item.parentElement.querySelectorAll('.block__childlink-item');
  
      siblings.forEach(sib => sib.classList.remove('active'));
      item.classList.add('active');
    });
  });
// ==========================  Child menu active class add and remove on hover End ============================= //

// ==========================  Footer menu open closes in mobile  ============================= //
function toggleFooterMenu(element) {
  const menuList = element.closest(".menu-list");

  if (menuList) {
    const detailsContent = menuList.querySelector(".footer-block__details-content");
    if (detailsContent) {
      detailsContent.classList.toggle("open");
    }
  }
}

// ==========================  Filter Sticky Top Start  ============================= //
window.addEventListener('load', function () {
  if (window.innerWidth < 750) {
    const header = document.querySelector('.header-wrapper');
    const filters = document.querySelectorAll('aside#main-collection-filters, aside#main-search-filters');

    if (header && filters.length > 0) {
      const headerHeight = header.offsetHeight;

      filters.forEach(filter => {
        filter.style.top = `${headerHeight}px`;
      });
    }
  }
});
// ========================== Filter Sticky Top End   ============================= //

// ========================== login and register form show password   ============================= //

function showpassword(el) {
  const checkbox = el.querySelector('input[type="checkbox"]');
  const passwordInput = document.querySelectorAll('.password-field');

  checkbox.checked = !checkbox.checked;

  if (checkbox.checked) {
    passwordInput.forEach((e)=>{
      e.type = 'text';
    })
    el.classList.add('active');
  } else {
    passwordInput.forEach((e)=>{
      e.type = 'password';
    })
    el.classList.remove('active');
  }
}
// ========================== rebuy add to cart Click start   ============================= //
const observer = new MutationObserver(() => {
  const rebuyButtons = document.querySelectorAll('.rebuy-button');
  rebuyButtons.forEach(button => {
    if (!button.dataset.listenerAdded) {
      button.addEventListener('click', function () {
        const span = button.querySelector('span');
        const text = span?.textContent?.trim();

        if (text && (
          text.includes('Adding') ||
          text.includes('Added')
        )) {  
          setTimeout(function () {
            updateCart();
            let cartDrawer = document.querySelector('body.product cart-drawer');
            if(cartDrawer){
              cartDrawer.classList.add('active'); 
            }
          }, 1000);
        }
      });
      button.dataset.listenerAdded = 'true'; 
    }
  });
});
observer.observe(document.body, { childList: true, subtree: true });
// ========================== rebuy add to cart Click End   ============================= //

function openCart(event){
  console.log(event)
  let cartDrawer = document.querySelector('body.product cart-drawer');
  if(cartDrawer){
    event.preventDefault();
    cartDrawer.classList.add('active');
  }
}




// ========================== account page popup form   ============================= //

function openForm(button) {
  const addressForm = button.closest('.address-form');
  const formWrapper = addressForm.querySelector('.form-wrapper');
  if (formWrapper) {
    formWrapper.classList.add('active');
    document.querySelector('body').classList.add('overflow-hidden');
  }
}

function cancelForm(button) {
  const formWrapper = button.closest('.form-wrapper');
  if (formWrapper) {
    formWrapper.classList.remove('active');
    document.querySelector('body').classList.remove('overflow-hidden');
  }
}

// ========================== account page tab mobile ============================= //
if (window.innerWidth <= 990) {
  if(document.querySelector('.account-tabs-list ul')){
    const tabsList = document.querySelector('.account-tabs-list ul');
    const tabItems = tabsList.querySelectorAll('li');

    tabsList.addEventListener('click', (event) => {
      tabsList.classList.add('active')
      tabItems.forEach((tab) => tab.classList.add('active'));
    });
  }
}

// ========================== order history js ============================= //

function showBox(element){
  element.classList.toggle('active')
  element.closest('.order-history-data').querySelector('.order-list').classList.toggle('active')
  element.closest('.order-history-data').querySelector('.order-progress-bar-box').classList.toggle('active')
}


function openSizeChart(btn, event) {
  if (event) event.stopPropagation();
  const wrapper = document.querySelector('.size-chart-wrapper');
  const contentBox = wrapper.querySelector('.tables-list-wrapper'); 
  const overlay = wrapper.querySelector('.cart-drawer__overlay');
  if (!wrapper) return;
  wrapper.classList.add('active');
  document.body.classList.add('overflow-hidden');

  function closeSizeChart() {
    wrapper.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    window.removeEventListener('click', handleOutsideClick);
  }
  // Close button
  wrapper.querySelectorAll('.block__close-sizechart, .close-button')
    .forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeSizeChart();
      });
    });
  // Overlay click (BEST METHOD)
  overlay.addEventListener('click', function () {
    closeSizeChart();
  });
  // Outside content click
  function handleOutsideClick(e) {
    if (!contentBox.contains(e.target)) {
      closeSizeChart();
    }
  }
  setTimeout(() => {
    window.addEventListener('click', handleOutsideClick);
  }, 0);
}


